import React, { PureComponent } from "react";
import { Flex, Text, CTag, CFontIcon } from "@appcues/component-library";

class AddTagControl extends PureComponent {
  state = {
    isHovering: false
  };
  onMouseEnterAddIcon = () => {
    this.setState({ isHovering: true });
  };
  onMouseLeaveAddIcon = () => {
    this.setState({ isHovering: false });
  };
  render() {
    const { toggleTagSelector } = this.props;
    const { isHovering } = this.state;

    return (
      <Flex alignItems="center" onClick={toggleTagSelector}>
        <CTag
          onMouseEnter={this.onMouseEnterAddIcon}
          onMouseLeave={this.onMouseLeaveAddIcon}
          backgroundColor={isHovering ? "$green-dark" : undefined}
        >
          <CFontIcon className="fas fa-plus" light={!!isHovering} />
        </CTag>
        {isHovering && (
          <Text type="tertiary" fontSize={14} marginLeft={8} fontWeight={600}>
            Add a tag
          </Text>
        )}
      </Flex>
    );
  }
}

export default AddTagControl;
